import Vue from 'vue';

const archistarRoutes = [
  {
    path: '/archistar',
    component: () => import('@/layouts/main/archistar/Main.vue'),
    children: [
      {
        path: 'companies',
        name: 'archistar.companies',
        component: () => import('@/components/archistar/table/UserCompanyTable.vue'),
        props: {
          scope: 'archistar.companies'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Archistar'
            },
            {
              title: 'Companies',
              active: true
            }
          ],
          pageTitle: 'Archistar Companies',
          hideDefaultHeader: true,
          rules: [
            {
              resource: 'users',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'users',
        name: 'archistar.users',
        component: () => import('@/components/archistar/table/UserCompanyTable.vue'),
        props: {
          scope: 'archistar.users'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Archistar'
            },
            {
              title: 'Users',
              active: true
            }
          ],
          pageTitle: 'Archistar Users',
          hideDefaultHeader: true,
          rules: [
            {
              resource: 'users',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'city-authority-companies',
        name: 'archistar.authority_access_cities_companies',
        component: () => import('@/components/archistar/table/UserCompanyTable.vue'),
        props: {
          scope: 'archistar.authority_access_cities_companies'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Archistar'
            },
            {
              title: 'City Authority Companies',
              active: true
            }
          ],
          pageTitle: 'City Accounts',
          hideDefaultHeader: true,
          rules: [
            {
              resource: 'users',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'city-api-vendors',
        name: 'archistar.api_access_cities_companies',
        component: () => import('@/components/archistar/table/UserCompanyTable.vue'),
        props: {
          scope: 'archistar.api_access_cities_companies'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Archistar'
            },
            {
              title: 'City API Vendors',
              active: true
            }
          ],
          pageTitle: 'City API Vendors',
          hideDefaultHeader: true,
          rules: [
            {
              resource: 'users',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'scenario-archichats',
        name: 'archistar.scenario_archichats',
        component: () => import('@/views/archistar/ScenarioArchichats.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Archistar'
            },
            {
              title: 'Scenario Archichats',
              active: true
            }
          ],
          pageTitle: 'Scenario Archichats',
          hideDefaultHeader: true,
          rules: [
            {
              resource: 'users',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'urban-copilot-usage',
        name: 'archistar.urban_copilot_usage',
        component: () => import('@/views/archistar/UrbanCopilotUsage.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Archistar'
            },
            {
              title: 'Urban Copilot Usage',
              active: true
            }
          ],
          pageTitle: 'Urban Copilot Usage',
          hideDefaultHeader: true,
          rules: [
            {
              resource: 'users',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'precheck-users',
        name: 'archistar.precheck_users',
        component: () => import('@/components/archistar/table/UserCompanyTable.vue'),
        props: {
          scope: 'archistar.precheck_users'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Archistar'
            },
            {
              title: 'PreCheck Self-Serve Users',
              active: true
            }
          ],
          pageTitle: 'PreCheck Self-Serve Users',
          hideDefaultHeader: true,
          rules: [
            {
              resource: 'users',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'forma-users',
        name: 'archistar.forma_users',
        component: () => import('@/components/archistar/table/UserCompanyTable.vue'),
        props: {
          scope: 'archistar.forma_users'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Archistar'
            },
            {
              title: 'Forma Users',
              active: true
            }
          ],
          pageTitle: 'Forma Users',
          hideDefaultHeader: true,
          rules: [
            {
              resource: 'users',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'forma-projects',
        name: 'archistar.forma_projects',
        component: () => import('@/components/archistar/table/table.vue'),
        props: {
          scope: 'archistar.forma_projects',
          defaultPageSize: 50,
          chunkSize: 500
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Archistar'
            },
            {
              title: 'Forma Projects',
              active: true
            }
          ],
          pageTitle: 'Forma Projects',
          hideDefaultHeader: true,
          rules: [
            {
              resource: 'users',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'archiland-users',
        name: 'archistar.archiland_users',
        component: () => import('@/components/archistar/table/UserCompanyTable.vue'),
        props: {
          scope: 'archistar.archiland_users'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Archistar'
            },
            {
              title: 'Archiland Users',
              active: true
            }
          ],
          pageTitle: 'Archiland Users',
          hideDefaultHeader: true,
          rules: [
            {
              resource: 'users',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'government-companies',
        name: 'archistar.government_companies',
        component: () => import('@/components/archistar/table/UserCompanyTable.vue'),
        props: {
          scope: 'archistar.government_companies'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Archistar'
            },
            {
              title: 'Government Companies',
              active: true
            }
          ],
          pageTitle: 'Government Companies',
          hideDefaultHeader: true,
          rules: [
            {
              resource: 'users',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'city-mode-companies',
        name: 'archistar.city_mode_companies',
        component: () => import('@/components/archistar/table/UserCompanyTable.vue'),
        props: {
          scope: 'archistar.city_mode_companies'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Archistar'
            },
            {
              title: 'City Mode Companies',
              active: true
            }
          ],
          pageTitle: 'City Mode Companies',
          hideDefaultHeader: true,
          rules: [
            {
              resource: 'users',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'city-mode-users',
        name: 'archistar.city_mode_users',
        component: () => import('@/components/archistar/table/UserCompanyTable.vue'),
        props: {
          scope: 'archistar.city_mode_users'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Archistar'
            },
            {
              title: 'City Mode Users',
              active: true
            }
          ],
          pageTitle: 'City Mode Users',
          hideDefaultHeader: true,
          rules: [
            {
              resource: 'users',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'city-managed-companies',
        name: 'archistar.city_managed_companies',
        component: () => import('@/components/archistar/table/UserCompanyTable.vue'),
        props: {
          scope: 'archistar.city_managed_companies'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Archistar'
            },
            {
              title: 'City Managed Companies',
              active: true
            }
          ],
          pageTitle: 'City Managed Companies',
          hideDefaultHeader: true,
          rules: [
            {
              resource: 'users',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'city-managed-users',
        name: 'archistar.city_managed_users',
        component: () => import('@/components/archistar/table/UserCompanyTable.vue'),
        props: {
          scope: 'archistar.city_managed_users'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Archistar'
            },
            {
              title: 'City managed Users',
              active: true
            }
          ],
          pageTitle: 'City managed Users',
          hideDefaultHeader: true,
          rules: [
            {
              resource: 'users',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'bulk-scenario-creation',
        name: 'archistar.archiland_users',
        component: () => import('@/components/archistar/table/UserCompanyTable.vue'),
        props: {
          scope: 'archistar.bulk_scenario_creation'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Archistar'
            },
            {
              title: 'Bulk Scenario Creation',
              active: true
            }
          ],
          pageTitle: 'Bulk Scenario Creation',
          hideDefaultHeader: true,
          rules: [
            {
              resource: 'users',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'scenario-pipeline-export',
        name: 'archistar.scenario_pipeline_export',
        component: () => import('@/components/archistar/table/UserCompanyTable.vue'),
        props: {
          scope: 'archistar.scenario_pipeline_export'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Archistar'
            },
            {
              title: 'Scenario Pipeline Export',
              active: true
            }
          ],
          pageTitle: 'Scenario Pipeline Export',
          hideDefaultHeader: true,
          rules: [
            {
              resource: 'users',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'documents',
        name: 'archistar.documents',
        component: () => import('@/components/archistar/document/DocumentTable.vue'),
        props: {
          scope: 'archistar.documents'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Archistar'
            },
            {
              title: 'Order Documents',
              active: true
            }
          ],
          pageTitle: 'Archistar - Order Documents',
          rules: [
            {
              resource: 'view documents',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'tooltips',
        name: 'archistar.tooltips',
        component: () => import('@/components/archistar/tooltips/TooltipsTable.vue'),
        props: {
          scope: 'archistar.tooltips'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Archistar'
            },
            {
              title: 'Tooltips',
              active: true
            }
          ],
          pageTitle: 'Archistar - Tooltips',
          rules: [
            {
              resource: 'users',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'useranalytics',
        name: 'archistar.useranalytics',
        component: () => import('@/components/archistar/table/UserCompanyTable.vue'),
        props: {
          scope: 'archistar.useranalytics'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Archistar'
            },
            {
              title: 'User Analytics',
              active: true
            }
          ],
          pageTitle: 'User Analytics',
          hideDefaultHeader: true,
          rules: [
            {
              resource: 'dataDashboard',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'overallanalytics',
        name: 'archistar.overallanalytics',
        component: () => import('@/views/archistar/AnalyticsDashboard.vue'),
        props: {
          type: 'overall',
          guid: null,
          startDate: Vue.moment().startOf('month').format('YYYY-MM-DD hh:mm'),
          endDate: Vue.moment().endOf('month').format('YYYY-MM-DD hh:mm')
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Archistar'
            },
            {
              title: 'Overall Analytics',
              active: true
            }
          ],
          pageTitle: 'Overall Analytics',
          rules: [
            {
              resource: 'dataDashboard',
              rule: 'read'
            }
          ]
        }
      }
    ]
  }
];

export default archistarRoutes;
